import React, { useMemo } from "react";

import { deriveStockStatus } from "../utils/inventoryHelpers";
import { formatCurrency } from "@/utils/formatCurrency";

function Tile({ label, value, accent = "text-[#333333]" }) {
  return (
    <div className="flex flex-col gap-1 min-w-[150px]">
      <p className="text-sm text-[#666]">{label}</p>
      <span className={`text-[20px] font-semibold ${accent}`}>{value}</span>
    </div>
  );
}

export default function InventorySummary({ items = [] }) {
  const stats = useMemo(() => {
    let low = 0;
    let out = 0;
    let stockValue = 0;

    items.forEach((item) => {
      const status = deriveStockStatus(item);
      if (status === "low") low += 1;
      if (status === "out") out += 1;
      stockValue += Number(item.onHand ?? 0) * Number(item.costPrice ?? 0);
    });

    return { total: items.length, low, out, stockValue };
  }, [items]);

  return (
    <div className="mb-6 rounded-lg bg-white border border-[#e4e4e4] px-5 py-4 shadow-sm">
      <div className="flex flex-wrap gap-8">
        <Tile label="Tracked SKUs" value={stats.total} />
        <Tile label="Low Stock" value={stats.low} accent="text-amber-600" />
        <Tile label="Out of Stock" value={stats.out} accent="text-red-600" />
        <Tile label="Stock Value (cost)" value={formatCurrency(stats.stockValue)} />
      </div>
    </div>
  );
}
